var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitfullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "docsvg exiticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.7,280.3h-73.1c-6,0-10.9,4.9-10.9,10.9s4.9,10.9,10.9,10.9h46.7l-78,77.9c-4.3,4.3-4.3,11.2,0,15.5 c2.1,2.1,4.9,3.2,7.7,3.2c2.8,0,5.6-1.1,7.7-3.2l78-77.9v46.7c0,6,4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9v-73.1 C231.7,285.2,226.8,280.3,220.7,280.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,508.7c139.5,0,252.5-113,252.5-252.5S395,3.7,255.5,3.7S3,116.7,3,256.2S116.1,508.7,255.5,508.7z  M255.5,17.4c131.9,0,238.8,106.9,238.8,238.8S387.4,495,255.5,495S16.7,388.1,16.7,256.2S123.6,17.4,255.5,17.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.2,116.8L299,196.9v-46.7c0-6-4.9-10.9-10.9-10.9c-6,0-10.9,4.9-10.9,10.9v73.1c0,6,4.9,10.9,10.9,10.9h73.1 c6,0,10.9-4.9,10.9-10.9c0-6-4.9-10.9-10.9-10.9h-46.7l80.2-80.1c4.3-4.3,4.3-11.2,0-15.5C390.4,112.5,383.5,112.5,379.2,116.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitfullscreen);
export default __webpack_public_path__ + "static/media/exitfullscreen.73aa96612b36c6f30ce4c08b80026f29.svg";
export { ForwardRef as ReactComponent };